module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLogined) ? _c('div', {
    staticClass: "paymentContent"
  }, [_c('div', {
    staticClass: "paymentInfo"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "titleLabel"
  }, [_vm._v("选择付款方式")]), _vm._v(" "), _c('div', {
    staticClass: "orderCodeLabel",
    attrs: {
      "title": _vm.orderCodes
    }
  }, [_vm._v("订单号：" + _vm._s(_vm.omitString(_vm.orderCodes, 39)))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "head"
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('div', {
    staticClass: "orderInfo"
  }, [_c('div', {
    attrs: {
      "title": _vm.orderCodes
    }
  }, [_vm._v("订单号：" + _vm._s(_vm.omitString(_vm.orderCodes, 28)))]), _c('div', [_vm._v("实付：￥" + _vm._s(Number(_vm.totalAmount).toFixed(2)))])]), _vm._v(" "), _c('div', {
    staticClass: "payType"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.payType),
      callback: function($$v) {
        _vm.payType = $$v
      },
      expression: "payType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_c('img', {
    attrs: {
      "src": "http://img.static.knnnj.com/Default/6bb4e732-162f-4cae-9bff-2b4f2e3d6797.png"
    }
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "立即付款"
    },
    on: {
      "click": _vm.paySuc
    }
  }), _vm._v(" "), _c('div', [_vm._v("剩余付款时间："), _c('span', [_vm._v(_vm._s(_vm.countDownContent))])])])])]) : _c('div', {
    staticClass: "paymentContent1"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.toLogin()
      }
    }
  }, [_vm._v("亲,请先登陆")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7030816a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/payment.vue
// module id = 773
// module chunks = 2